import React from 'react';
import theme from '../theme/theme';
import { Button, Box, Grid, Typography, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Header, SearchBar } from '../components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFutbol } from '@fortawesome/free-solid-svg-icons';

//import sponsors from '../assets/img/background-sponsors.png'

function Home() {

  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const navigate = useNavigate();

  return (
    <div>

      <Header page="Home" />

      <Grid container direction="column" style={{backgroundColor: theme.palette.grey[200]}}>

        <Box id="home" /* SECTION 1: HOME */>
        <Grid item
        container direction="column" alignItems="center" justifyContent="center"
        sx={{ pt: 5, minHeight: '100vh'}}>

          <Grid item>

            <Grid container direction="row" 
            alignItems="flex-start"
            sx={{py: 7, px: isSmUp ? 5 : 1}}>
              <Grid item xs={12} md={6} sx={{px: isSmUp ? 5 : 2, py: 5}}>

                <Typography variant="h3" align="center">
                  <span style={{color: theme.palette.primary.main}}>Create</span> League
                </Typography>

                <Typography align="center"
                sx={{mt: 5, fontSize: isSmUp ? '22px' : '16px', fontWeight: '300', color: theme.palette.grey[700]}}>
                  Create a World Cup '26 predictor league for colleagues, friends or family.
                </Typography>

                <Box sx={{textAlign:'center', mt: 5.2}}>
                  <Button
                  onClick={e => navigate('/league/create/0')}
                  size="large" variant="contained"
                  sx={{fontSize: '18px', fontWeight: '600', borderRadius: '30px', padding: '15px 35px'}}>
                    <FontAwesomeIcon icon={faFutbol}/>&nbsp;&nbsp;Create league
                  </Button>
                </Box>

              </Grid>
              <Grid item xs={12} md={6} sx={{px: 5, py: 5}}>

                <Typography variant="h3" align="center">
                  <span style={{color: theme.palette.primary.main}}>Join</span> League
                </Typography>

                <Typography align="center"
                sx={{mt: 5, fontSize: isSmUp ? '22px' : '16px', fontWeight: '300', color: theme.palette.grey[700]}}>
                  Find and join a predictor league, created by someone that you know.
                </Typography>

                <Grid container direction="column" alignItems="center" justifyContent="center" sx={{mt: 4}}>
                  <Grid item>
                    <Box sx={{width: isMdUp ? '340px' : isSmUp ? '320px' : '280px'}}>
                      <SearchBar />
                    </Box>
                  </Grid>
                </Grid>

              </Grid>
            </Grid>

          </Grid>
          {/*
          <Grid item>
            <Box style={{position: 'absolute', right: '0px', bottom: '0px'}}>
            <img src={sponsors} alt="sponsors" />
            </Box>

          </Grid>
          */}

        </Grid>
        </Box>

      </Grid>

    </div>
  );
}

export default Home;